
import { SiriusBaseComponent } from 'sirius-framework';
import { Router } from '@angular/router';
import { Component, OnDestroy } from '@angular/core';
import { CommonService } from '../../../shared/service/shared.service';
import { SiteLanguageService } from '../../../shared/service/site-language.service';
import { Subscription } from 'rxjs';

/** String resource — boşsa/placeholder ise Türkçe varsayılan */
const INNER_MENU_CONTENT_KEYS = {
    title: 'yediEminInnerMenuTitle',
    sellerCardTitle: 'yediEminInnerMenuSellerCardTitle',
    sellerCardText: 'yediEminInnerMenuSellerCardText',
    buyerCardTitle: 'yediEminInnerMenuBuyerCardTitle',
    buyerCardText: 'yediEminInnerMenuBuyerCardText',
    liveProcessCardTitle: 'yediEminInnerMenuLiveProcessCardTitle',
    liveProcessCardText: 'yediEminInnerMenuLiveProcessCardText',
};

@Component({
    selector: 'inner-menu-content',
    templateUrl: './inner-menu-content.component.html',
    styleUrls: ['./inner-menu-content.component.css']
})
export class InnerMenuContentComponent extends SiriusBaseComponent<any> implements OnDestroy {
    titleText= 'İşlemler';
    sellerCardTitle = 'Satıcı İşlemleri';
    sellerCardText = 'Bireysel/tüzel satıcı ve araç bilgisi girişi';
    buyerCardTitle = 'Alıcı İşlemleri';
    buyerCardText = 'Satış işlemi onay ve bireysel/tüzel alıcı bilgi girişi';
    liveProcessCardTitle = 'Devam Eden İşlemler';
    liveProcessCardText = 'Devam eden alış/satış işlemlerinizin durumu';

    private langSub: Subscription;

    constructor(
        public router: Router,
        private commonService: CommonService,
        private siteLanguage: SiteLanguageService) {
        super();
    }

    OnInit() {
        this.langSub = this.siteLanguage.languageCode$.subscribe(() => this.loadInnerMenuContentResourceStrings());
    }

    private loadInnerMenuContentResourceStrings(): void {
        this.titleText = this.commonService.getStringResource(INNER_MENU_CONTENT_KEYS.title, this.titleText || 'İşlemler');
        this.sellerCardTitle = this.commonService.getStringResource(INNER_MENU_CONTENT_KEYS.sellerCardTitle, this.sellerCardTitle);
        this.sellerCardText = this.commonService.getStringResource(INNER_MENU_CONTENT_KEYS.sellerCardText, this.sellerCardText);
        this.buyerCardTitle = this.commonService.getStringResource(INNER_MENU_CONTENT_KEYS.buyerCardTitle, this.buyerCardTitle);
        this.buyerCardText = this.commonService.getStringResource(INNER_MENU_CONTENT_KEYS.buyerCardText, this.buyerCardText);
        this.liveProcessCardTitle = this.commonService.getStringResource(INNER_MENU_CONTENT_KEYS.liveProcessCardTitle, this.liveProcessCardTitle);
        this.liveProcessCardText = this.commonService.getStringResource(INNER_MENU_CONTENT_KEYS.liveProcessCardText, this.liveProcessCardText);
    }

    ngOnDestroy() {
        if (this.langSub) {
            this.langSub.unsubscribe();
        }
    }
}
